import { useLocation, useNavigate } from 'react-router-dom'
import React from 'react'
import { AppSelect } from '../../../../form/component/analog/AppSelect'
import { AppOption } from '../../../../form/component/analog/AppOption'
import { NavModel } from '../../../../../model/Nav'

interface Props {
  nav: NavModel
}

export function DropdownNav({ nav }: Props) {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const handleChange: React.ChangeEventHandler<any> = e => navigate(e.target.value)
  const list = Object.entries(nav)

  return (
    <AppSelect
      onChange={handleChange}
      value={pathname}
      sx={appSelectStyles}
    >
      {list.filter(([_, { props }]) => !props.hidden).map(([id, { label, props }]) => (
        <AppOption
          key={id}
          value={props.link}
          textValue={label}
          sx={appOptionStyles}
        />
      ))}
    </AppSelect>
  )
}

const appSelectStyles = {
  backgroundSize: '14px',
  backgroundPosition: 'center right 16px',
  color: 'text.primary',
  fontSize: '14px',
  textAlign: 'center',
  fontWeight: 300,
  transition: 'color 0.2s ease',
  width: '85%',
  border: 'none',
  outline: 'none',
  boxShadow: 'none',
  '&:focus': {
    backgroundColor: 'background.paper',
    color: 'text.secondary',
    outline: 'none',
    boxShadow: 'none',
  },
}

const appOptionStyles = {
  backgroundColor: 'background.paper',
  color: 'text.secondary',
  fontSize: '14px',
  textAlign: 'center',
}